/* @flow weak */

'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const ProductStore = require('../../stores/ProductStore.jsx');
const AnswerActions = require('../../actions/AnswerActions.jsx');
const SwearWords = require('../../content/SwearWords.json');
const SwearStrings = require('../../content/SwearStrings.json');

const ControlMixin = require('../../mixins/ControlMixin.jsx');

const _ = require('lodash');
const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const InsideEngraving = React.createClass({
  mixins: [ControlMixin],

  greekLetters: [
    'Α', 'Β', 'Γ', 'Δ', 'Ε', 'Ζ', 'Η', 'Θ',
    'Ι', 'Κ', 'Λ', 'Μ', 'Ν', 'Ξ', 'Ο', 'Π',
    'Ρ', 'Σ', 'Τ', 'Υ', 'Φ', 'Χ', 'Ψ', 'Ω'
  ],

  getInitialState() {
    return {
      engravingType: 'standard',
      standardValue: '',
      standardCharsLeft: _.get(this.props.question, 'constraints.MaxLength'),
      greekValue: '',
      greekCharsLeft: _.get(this.props.question, 'constraints.MaxLengthIfGreek'),
    };
  },

  handleToggleType() {
    this.setState({
      engravingType: this.state.engravingType === 'standard' ? 'greek' : 'standard'
    }, function() {
      const newValue = this.state.engravingType === 'standard' ? this.state.standardValue : this.state.greekValue;
      this.handleChangeText(newValue);
      this.trackUpdate(newValue);
    });
  },

  handleChangeGreek(letter) {
    let maxLengthIfGreek = _.get(this.props.question, 'constraints.MaxLengthIfGreek');
    let currentInputValue = ReactDOM.findDOMNode(this.refs.greekInput).value;
    let newText = '';
    let charsLeft;

    switch(letter) {
      case 'clear':
        newText = '';
        charsLeft = maxLengthIfGreek;
        break;
      case 'backspace':
        newText = currentInputValue.length > 0 ? currentInputValue.substring(0, currentInputValue.length - 1) : '';
        charsLeft = currentInputValue.length > 0 ? this.state.greekCharsLeft + 1 : maxLengthIfGreek;
        break;
      default:
        newText = currentInputValue.concat([letter]);
        charsLeft = this.state.greekCharsLeft > 0 ? this.state.greekCharsLeft - 1 : 0;
    }

    if (maxLengthIfGreek) {
      let valueLength = _.get(newText, 'length');
      let charsLeft = maxLengthIfGreek - valueLength;

      if (charsLeft < 0) {
        return;
      }

      this.setState({
        greekValue: newText,
        greekCharsLeft: charsLeft
      });
    } else {
      this.setState({
        greekValue: newText
      });
    }

    this.handleChangeText(newText);
    this.trackUpdate(newText);
  },

  handleTextHydration(text) {
    let greekRegex = /[ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ]/;
    let standardValue = '';
    let greekValue = '';
    let engravingType = 'standard';

    if (greekRegex.test(text)) {
      greekValue = text;
      engravingType = 'greek';
    } else {
      standardValue = text;
    }

    this.setState({
      engravingType: engravingType,
      standardValue: engravingType === 'standard' ? text : this.state.standardValue,
      greekValue: engravingType === 'greek' ? text : this.state.greekValue,
    });
  },

  renderGreekRoyaltyMsg() {
    let greekRoyalty = ProductStore.getGreekRoyalty();

    if (!greekRoyalty) {
      return null;
    }

    // @TODO Make the below message be data driven (question metadata)
    return (
      <p>
        *For Greek lettering, there is a ${ProductStore.getGreekRoyalty()} flat fee, regardless of how many are chosen; however, if you're charged for Greek encrusting, then this charge won't apply.
      </p>
    );
  },

  handleChangeStandard(e) {
    let inputValue = e.target.value;
    let maxLength = _.get(this.props.question, 'constraints.MaxLength');

    let answerInput = inputValue.toLowerCase().trim();
    let fullMatch = _.some(SwearWords, (badWord) => {
      return badWord === answerInput;
    });

    let partialMatch = _.some(SwearStrings, (string) => {
      return  _.includes(answerInput, string);
    });
    const regex = /^[A-Za-z0-9 `#!',"\-\.\(\):;\?&<>\/$%\[\]^©+|_°=~@♥®™℠\\*]+$/;
    let valid = !fullMatch && !partialMatch && (inputValue.length < 1 || regex.test(inputValue));
    this.setState({valid});
    if (!valid) {
      return;
    }

    if (maxLength) {
      let valueLength = _.get(inputValue, 'length');
      let charsLeft = maxLength - valueLength;

      if (charsLeft < 0) {
        return;
      }

      this.setState({
        standardCharsLeft: charsLeft
      });
    }

    this.setState({
      standardValue: inputValue
    });
    this.handleChangeText(inputValue);
  },

  render() {
    let maxLength = _.get(this.props.question, 'constraints.MaxLength');
    let maxLengthIfGreek = _.get(this.props.question, 'constraints.MaxLengthIfGreek');
    let placeholder = _.get(this.props.question.metadata, `lang.${ln}.DisplayInputPlaceholder`) || '';

    return (
      <div className='uc-control uc-inside-engraving'>

        {/* Link that switches between standard and greek engraving */}
        <div className="uc-input-links">
          <a className={ this.state.engravingType === 'greek' ? 'uc-active' : '' } 
            onClick={this.state.locked ? null : this.handleToggleType} 
            tabIndex={this.props.tabIndex}>
            Click to Select Greek Letters ( Additional cost ${ProductStore.getGreekRoyalty()})
          </a>
        </div>


        {/* Standard Engraving Control */}
        <div style={{ display: this.state.engravingType === 'standard' ? 'block' : 'none' }}>
          <div className="uc-part-price" style={{ display: this.displayPrice(this.props.parts[0]) ? 'block' : 'none' }}>
            { this.displayPrice(this.props.parts[0]) ? this.displayPrice(this.props.parts[0]) : '' }
          </div>

          <input
            aria-label="Inside Engraving"
            ref='standardInput'
            type='text'
            tabIndex={this.props.tabIndex}
            value={this.state.standardValue}
            onChange={this.state.locked ? null : this.handleChangeStandard}
            onBlur={this.handleBlur}
            disabled={this.state.locked}
            placeholder={placeholder}
            style={{ width: this.displayPrice(this.props.parts[0]) ? '75%' : '100%' }} />
          {
            maxLength ? <div className="uc-chars-left">{this.state.standardCharsLeft} {(Config.features.charactersLeftText[ln] || onfig.features.charactersLeftText['en_US'])}</div>
            : null
          }
        </div>


        {/* Greek Engraving control */}
        <div style={{ display: this.state.engravingType === 'greek' ? 'block' : 'none' }}>
          <div className="uc-part-price" style={{ display: this.displayPrice(this.props.parts[0]) ? 'block' : 'none' }}>
            { this.displayPrice(this.props.parts[0]) ? this.displayPrice(this.props.parts[0]) : '' }
            { this.renderGreekRoyaltyMsg() ? '*' : '' }
          </div>

          <input
            aria-label="Greek Engraving"
            ref='greekInput'
            type='text'
            tabIndex={this.props.tabIndex}
            value={this.state.greekValue}
            style={{ width: this.displayPrice(this.props.parts[0]) ? '75%' : '100%' }} 
            disabled={this.state.locked}
            placeholder={placeholder}
            readOnly />
          {
            maxLengthIfGreek ? <div className="uc-chars-left">{this.state.greekCharsLeft} {(Config.features.charactersLeftText[ln] || onfig.features.charactersLeftText['en_US'])}</div>
            : null
          }

          {!this.state.locked ? (
            <ul className='uc-greek-keyboard'>
              {_.map(this.greekLetters, function(letter, index) {
                return (
                  <li role='option' onClick={this.handleChangeGreek.bind(null, letter)} key={index}>{letter}</li>
                );
              }.bind(this))}

              <li role='button' className='uc-backspace-button' onClick={this.handleChangeGreek.bind(null, 'backspace')}>BACKSPACE</li>
              <li role='button' className='uc-clear-button' onClick={this.handleChangeGreek.bind(null, 'clear')}>CLEAR</li>
            </ul>
            ) : null          
          }

          {this.renderGreekRoyaltyMsg()}
        </div>
      </div>
    );
  }
});

module.exports = InsideEngraving;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/InsideEngraving.jsx